import type { BusinessUnit } from '@backend/lib-l10n';

import { getJobsBusinessUnitUrlPath, getJobsUrl } from '~/config';
import { businessUnits } from '~/config/businessUnits';

export const getMissionUrlPath = (businessUnit: BusinessUnit, slug: string) =>
  `${getJobsBusinessUnitUrlPath(businessUnit)}/${businessUnits[businessUnit].paths.jobOffer}/${slug}`;

export const getMissionUrl = (businessUnit: BusinessUnit, slug: string) =>
  `${getJobsUrl()}${getMissionUrlPath(businessUnit, slug)}`;

export const getMissionUrlApplyPath = (businessUnit: BusinessUnit, slug: string) =>
  `${getMissionUrlPath(businessUnit, slug)}/${businessUnits[businessUnit].paths.apply}`;

export const isMissionApplyUrl = (businessUnit: BusinessUnit, url: string) =>
  url.split('?')[0].endsWith(`/${businessUnits[businessUnit].paths.apply}`);
